import React from 'react';
import { Check, ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
import { trackEventThenNavigate } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://rugby-360.impultienda.ar/checkout';
const included = ['Complete Box Set (14 volumes)', '6 Strategic Bonuses', '365-Day Coaching Curriculum', 'Lifetime access', 'Instant digital access'];
export function Pricing() {
  const goToCheckout = () => {
    // Send InitiateCheckout with the offer's value, then redirect once the
    // beacon has actually left the browser.
    trackEventThenNavigate('InitiateCheckout', CHECKOUT_URL, {
      content_name: 'Rugby 360 — Complete Box Set',
      content_type: 'product',
      value: 27,
      currency: 'USD'
    });
  };
  return <section id="offer-details" className="bg-[#F4F6F2] px-4 py-14 md:py-24" data-id="element-155" data-mp="20rto7s4wvq3y">
      <div className="max-w-3xl mx-auto" data-id="element-156" data-mp="3h63dqpkw3kwd">
        <div className="text-center mb-9 md:mb-12" data-id="element-157" data-mp="3c8a6rubrimv1">
          <span className="inline-block bg-ink text-acid text-[0.65rem] md:text-[11px] font-bold uppercase tracking-[0.16em] px-4 py-2 md:px-5 md:py-2.5 mb-5 md:mb-7" data-id="element-158" data-mp="3c7i98dyluf24">
            Limited-time offer
          </span>
          <h2 className="font-display uppercase text-gray-900 text-[7.4vw] min-[430px]:text-3xl md:text-5xl leading-[1.05] mb-3" data-id="element-159" data-mp="4rb1806efjv0">
            Everything included,{' '}
            <span className="text-neon-deep" data-id="element-160" data-mp="eqaclqijttlp">one single price.</span>
          </h2>
          <p className="text-gray-500 text-sm md:text-lg" data-id="element-161" data-mp="3d9h557p9bxwi">
            No upsells. No surprises.
          </p>
        </div>

        <div className="bg-white shadow-xl border-t-4 border-neon" data-id="element-162" data-mp="3i8tvi2fc7n3u">
          <header className="bg-ink text-center px-5 py-7 md:px-6 md:py-9" data-id="element-163" data-mp="3n6lj4k8y8n28">
            <h3 className="font-display uppercase text-white text-xl md:text-3xl leading-tight mb-2" data-id="element-164" data-mp="3rxv7lhirhkcj">
              Rugby 360 — Complete Box Set
            </h3>
            <p className="text-acid text-xs md:text-base font-medium" data-id="element-165" data-mp="2uhy599qj4zyp">
              1 Main Box Set (14 volumes) + 6 Strategic Bonuses
            </p>
          </header>

          <div className="p-5 md:p-10" data-id="element-166" data-mp="2rg33i109nume">
            <p className="text-center text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.16em] text-gray-500 mb-5 md:mb-7" data-id="element-167" data-mp="2rf1pbnnyes0g">
              What's included
            </p>

            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3 md:gap-y-4 mb-8 md:mb-10" data-id="element-168" data-mp="315cyppqepteq">
              {included.map(item => <li key={item} className="flex items-center gap-2.5 md:gap-3" data-id="element-169" data-mp="2w9xkuxsefxib">
                  <span className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-neon/20 text-neon-deep flex items-center justify-center flex-shrink-0" data-id="element-170" data-mp="28i8zk1dzw9av">
                    <Check size={13} strokeWidth={3} aria-hidden="true" data-id="element-171" data-mp="2ifwrkjk7v2pc" />
                  </span>
                  <span className="font-bold text-gray-900 text-[0.85rem] md:text-[0.95rem]" data-id="element-172" data-mp="2dhd60k9jbsxi">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="border-t border-gray-200 pt-7 md:pt-9 text-center" data-id="element-173" data-mp="3owil6nqurjy0">
              <p className="text-gray-500 text-sm md:text-base mb-2" data-id="element-174" data-mp="3oylebgnaxt6y">
                Regular price: <span className="line-through" data-id="element-175" data-mp="cgl43a1131g">$97 USD</span>
              </p>

              <div className="flex items-start justify-center gap-1 mb-5" data-id="element-176" data-mp="5b1ky1ld9kpd">
                <span className="font-display text-gray-900 text-3xl md:text-5xl mt-2 md:mt-3" data-id="element-177" data-mp="3ng4vw2y0kqxp">
                  $
                </span>
                <span className="font-display text-gray-900 text-[4.5rem] md:text-[7rem] leading-[0.85]" data-id="element-178" data-mp="3rirf5fgmd3ja">
                  27
                </span>
                <span className="text-gray-500 text-base md:text-xl font-medium self-end mb-2 md:mb-3 ml-1" data-id="element-179" data-mp="o07xf6vkhg2q">
                  USD
                </span>
              </div>

              <div className="flex flex-wrap items-center justify-center gap-2.5 md:gap-4 mb-7 md:mb-9" data-id="element-180" data-mp="ea52300z3q18">
                <span className="bg-neon text-ink text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.1em] px-3 py-1.5 md:px-4 md:py-2" data-id="element-181" data-mp="11zzghm0xxmnl">
                  Save $70
                </span>
                <span className="text-gray-600 text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.1em]" data-id="element-182" data-mp="3f78t0fsq3hg8">
                  One-time payment
                </span>
                <span className="text-gray-600 text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.1em]" data-id="element-183" data-mp="3aaiehwwkgtwx">
                  Lifetime access
                </span>
              </div>

              <button onClick={goToCheckout} className="w-full bg-neon hover:bg-neon-light text-ink font-display uppercase text-lg md:text-2xl tracking-wide py-5 md:py-6 rounded-xl shadow-[0_5px_0_0_var(--neon-deep)] active:translate-y-[3px] active:shadow-[0_2px_0_0_var(--neon-deep)] transition-all" data-id="element-184" data-mp="319k7d5qu06a4">
                Get Rugby 360 Now
              </button>

              <p className="flex items-center justify-center gap-2 text-gray-500 text-xs md:text-sm mt-4 md:mt-5" data-id="element-185" data-mp="3k6d3ravapn8o">
                <ShieldCheck className="text-neon-deep" size={15} data-id="element-186" data-mp="kkybvp7dwyne" />
                Backed by our 7-day money-back guarantee
              </p>
            </div>

            <div className="border-t border-gray-200 mt-7 md:mt-9 pt-5 md:pt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs md:text-sm text-gray-600" data-id="element-187" data-mp="1yggc2xfaau0o">
              <span className="flex items-center gap-1.5" data-id="element-188" data-mp="27g3813p8v7mc">
                <Lock size={14} data-id="element-189" data-mp="27hxrseos4tou" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-190" data-mp="2cfpij5dou9rg">
                <Zap size={14} data-id="element-191" data-mp="2he95n940prle" /> Instant access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-192" data-mp="2hbwqt4tk3xck">
                <CreditCard size={14} data-id="element-193" data-mp="2mc2a9xpoadjk" /> Card · GooglePay · ApplePay
              </span>
            </div>
          </div>
        </div>

        <p className="text-center text-gray-500 text-xs md:text-sm mt-5 md:mt-7" data-id="element-194" data-mp="2r4lxzni2qp23">
          You'll be charged in your local currency.
        </p>
      </div>
    </section>;
}